import axios from "axios";
import { PublicApi } from "../api/api";

export interface TankDataProps {
  tankUniqueId: string;
  tankVolume: string;
  manufactureDate: string | null;
  is_assigned?: boolean;
  createdAt?: string;
}
export interface SensorDataProps {
  tankDataId: string;
  _tank: string;
  tankLevel: string;
  tankTemperaure: string;
  tankOrientation: string;
  longitude: string;
  latitude: string;
  batteryLevel: string;
  waterHeight?: string;
  tankFullness?: string;
  tankStatus?: string;
  waterVolume?: string;
  waterTemperature?: string;
  ambientTemperature?: string;
  ambientHumidity?: string;
  sensorStatus?: string;
  createdAt?: string;
}

export const createTank = async (tankData: TankDataProps) => {
  try {
    const response = await PublicApi.post("/tanks/create/", {
      tankUniqueId: tankData.tankUniqueId,
      tankVolume: tankData.tankVolume,
      manufactureDate: tankData.manufactureDate,
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      console.error("Error response:", error.response.data);
    }
    throw error;
  }
};

export const fetchAllTanks = async () => {
  try {
    const response = await PublicApi.get("/tanks/all/");
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchAllTanksSensorData = async () => {
  try {
    const response = await PublicApi.get("/sensordata/");
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchUnassignedTanks = async () => {
  try {
    const response = await PublicApi.get("/tanks/unassigned/");
    return response;
  } catch (error) {
    throw error;
  }
};
